module.exports = __webpack_public_path__ + "img/yuan.f8c5af65.svg";